//TODO: rename this file to sliceNamesConstants.js
export const AUTH_SHOP = 'authShop';
export const APP = 'app';
export const ORDER = 'order';
export const LOADING = 'loading';